import DashboardContent from "../components/dashboard/dashboardContent";

export default function Dashboard() {
  return (
    <>
      <DashboardContent />
    </>
  );
}
